/* import __COLOCATED_TEMPLATE__ from './noise-calculations-tab.hbs'; */
import Component from '@ember/component';
import { service } from '@ember/service';

import { alias } from '@ember/object/computed';
import { computed, action } from '@ember/object';

export default class NoiseCalculationsTab extends Component {
    tagName = '';

    @service('data') model;
    @service urlData;
    @service intl;

    rmsNoiseCalculationsMaximized = false;
    noiseDensityCalculationsMaximized = false;

    modalBodyArgs = {};
    rmsNoiseBodyArgs = {};
    noiseDensityDetailsArg = {};

    @alias('model.noiseCalculations') noiseCalculations;

    init() {
        super.init();

        let sourceNoiseText = this.intl.t('info_modal.noise_contributions.source_noise_text');

        this.modalBodyArgs = {
            sourceNoiseText: this.model.showOptionalSourceSettings ? sourceNoiseText : '',
            opAmpVideoLink: this.intl.t('urls.videos.nonInvertingOpAmp'),
            mt047Pdf: this.intl.t('urls.articles.mt047'),
        };

        this.rmsNoiseBodyArgs = {
            video: this.intl.t('urls.videos.calculatingSpectralNoiseDensityToRMSNoise'),
        };

        this.noiseDensityDetailsArgs = {
            mt049Pdf: this.intl.t('urls.articles.mt049'),
            mt050Pdf: this.intl.t('urls.articles.mt050'),
            nonInvertingOpAmpVideo: this.intl.t('urls.videos.nonInvertingOpAmp'),
        };
    }

    @action showHideRmsNoiseCalculations() {
        this.set('rmsNoiseCalculationsMaximized', !this.rmsNoiseCalculationsMaximized);
    }

    @action showHideNoiseDensityCalculations() {
        this.set('noiseDensityCalculationsMaximized', !this.noiseDensityCalculationsMaximized);
    }

    @computed('noiseCalculations.driver.ibPlus.sourceInputDensity') get showIbPlusRows() {
        if (!(this.noiseCalculations.driver && this.noiseCalculations.driver.ibPlus)) return false;
        return !!this.noiseCalculations.driver.ibPlus.sourceInputDensity;
    }

    @computed('noiseCalculations.driver.ibMinus.sourceInputDensity') get showIbMinusRows() {
        if (!(this.noiseCalculations.driver && this.noiseCalculations.driver.ibMinus)) return false;
        return !!this.noiseCalculations.driver.ibMinus.sourceInputDensity;
    }

    @computed('rmsNoiseCalculationsMaximized') get rmsNoiseExpandCollapseIconInfo() {
        return this.getExpandCollapseIconInfo(this.rmsNoiseCalculationsMaximized);
    }

    @computed('noiseDensityCalculationsMaximized') get noiseDensityExpandCollapseIconInfo() {
        return this.getExpandCollapseIconInfo(this.noiseDensityCalculationsMaximized);
    }

    getExpandCollapseIconInfo(maximized) {
        if (maximized)
            return {
                alt: this.intl.t('labels.collapse'),
                src: 'svgs/icons/Icon_Collapse.svg',
            };
        else
            return {
                alt: this.intl.t('labels.expand'),
                src: 'svgs/icons/Icon_Expand.svg',
            };
    }
}
